const CircleSvg = () => {
  return ( 
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.49855 14.9971C11.6399 14.9971 14.9971 11.6399 14.9971 7.49855C14.9971 3.35722 11.6399 0 7.49855 0C3.35722 0 0 3.35722 0 7.49855C0 11.6399 3.35722 14.9971 7.49855 14.9971Z" fill="#ff9300"/>
    </svg>
  )}
  
  export default CircleSvg;
  